import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'
import Home from "./views/Home";
import Login from "./views/Login";
import LoggedIn from "./views/LoggedIn";
import Membership from "./views/Membership";
import ClassReport from "./views/ClassReport";
import Messages from "./views/Messages";
import KnowledgeBase from "./views/KnowledgeBase";
import Profile from "./views/Profile";
import KnowledgeBaseStep2 from "./views/KnowledgeBaseStep2";
import KnowledgeBaseStep3 from "./views/KnowledgeBaseStep3";
import KnowledgeBaseStep4 from "./views/KnowledgeBaseStep4";
import BuyMembership from "./views/BuyMembership";
import Attendance from "./views/Attendance";
import Performance from "./views/Performance";
import SpecialFile from "./views/SpecialFile";
import SpecialFileDetail from "./views/SpecialFileDetail"
import Points from "./views/Points";
import ClassScores from "./views/ClassScores";
import WeeklySchedule from "./views/WeeklySchedule";
import SpecialReports from "./views/SpecialReports";
import SpecialReportDetail from "./views/SpecialReportDetail";
import AboutApp from "./views/AboutApp";
import AboutSchool from "./views/AboutSchool";
import ConnectUs from "./views/ConnectUs";
import SocialMedia from "./views/SocialMedia";
import MessageDetail from "./views/MessageDetail";
import BuyMembershipPackageDetail from "./views/BuyMembershipPackageDetail";
import OnlineExam from "./views/OnlineExam";
import ExamDetail from "./views/ExamDetail";
import SurveyList from "./views/SurveyList";
import SurveyDetail from "./views/SurveyDetail";
import BMI from "./views/BMI";
import ScoreScheduleEachLesson from "./views/ReportDetailsPages/ScoreScheduleEachLesson";
import PerformanceChart from "./views/ReportDetailsPages/PerformanceChart";
import ActivityTopics from "./views/ReportDetailsPages/ActivityTopics";
import SevenIntelligences from "./views/ReportDetailsPages/SevenIntelligences";
import BMIChart from "./views/ReportDetailsPages/BMIChart";
import LiteracyChart from "./views/ReportDetailsPages/LiteracyChart";
import GeneralSkill from "./views/ReportDetailsPages/GeneralSkill";
import PerformanceIndividualExpertise from "./views/ReportDetailsPages/PerformanceIndividualExpertise";
import ExtentIndividualPotentialUse from "./views/ReportDetailsPages/ExtentIndividualPotentialUse";
import WhenIndividualAction from "./views/ReportDetailsPages/WhenIndividualAction";
import SleepChartReport from "./views/ReportDetailsPages/SleepChartReport";
import SleepQuality from "./views/SleepQuality";
import PhysicalHealth from "./views/ReportDetailsPages/PhysicalHealth";
import LearnEachLesson from "./views/ReportDetailsPages/LearnEachLesson";
import FunctionalIntegrity from "./views/ReportDetailsPages/FunctionalIntegrity";
import ReportPage from "./views/ReportDetailsPages/ReportPage";

Vue.use(VueRouter);
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/Login'
        },
        {
            path: "/Home",
            component: Home,
        },
        {
            path: "/Login",
            component: Login,
        },
        {
            path: "/LoggedIn",
            component: LoggedIn,
        },
        {
            path: "/Membership",
            component: Membership,
        },
        {
            path: "/ClassReport",
            component: ClassReport,
        },
        {
            path: "/Messages",
            component: Messages,
        },
        {
            path: "/KnowledgeBase",
            component: KnowledgeBase,
        },
        {
            path: "/Profile",
            component: Profile,
        },
        {
            path: "/KnowledgeBaseStep2",
            component: KnowledgeBaseStep2,
        },
        {
            path: "/KnowledgeBaseStep3",
            component: KnowledgeBaseStep3,
        },
        {
            path: "/KnowledgeBaseStep4",
            component: KnowledgeBaseStep4,
        },
        {
            path: "/BuyMembership",
            component: BuyMembership,
        },
        {
            path: "/Attendance",
            component: Attendance,
        },
        {
            path: "/Performance",
            component: Performance,
        },
        {
            path: "/SpecialFile",
            component: SpecialFile,
        },
        {
            path: "/SpecialFileDetail",
            component: SpecialFileDetail,
        },
        {
            path: "/Points",
            component: Points,
        },
        {
            path: "/ClassScores",
            component: ClassScores,
        },
        {
            path: "/WeeklySchedule",
            component: WeeklySchedule,
        },
        {
            path: "/SpecialReports",
            component: SpecialReports,
        },
        {
            path: "/SpecialReportDetail",
            component: SpecialReportDetail,
        },
        {
            path: "/AboutApp",
            component: AboutApp,
        },
        {
            path: "/AboutSchool",
            component: AboutSchool,
        },
        {
            path: "/ConnectUs",
            component: ConnectUs,
        },
        {
            path: "/SocialMedia",
            component: SocialMedia,
        },
        {
            path: "/MessageDetail",
            component: MessageDetail,
        },
        {
            path: "/BuyMembershipPackageDetail",
            component: BuyMembershipPackageDetail,
        },
        {
            path: "/OnlineExam",
            component: OnlineExam,
        },
        {
            path: "/ExamDetail",
            component: ExamDetail,
        },
        {
            path: "/SurveyList",
            component: SurveyList,
        },
        {
            path: "/SurveyDetail",
            component: SurveyDetail,
        },
        {
            path: "/BMI",
            component: BMI,
        },
        {
            path: "/ScoreScheduleEachLesson",
            component: ScoreScheduleEachLesson,
        },
        {
            path: "/PerformanceChart",
            component: PerformanceChart,
        },
        {
            path: "/ActivityTopics",
            component: ActivityTopics,
        },
        {
            path: "/SevenIntelligences",
            component: SevenIntelligences,
        },
        {
            path: "/BMIChart",
            component: BMIChart,
        },
        {
            path: "/LiteracyChart",
            component: LiteracyChart,
        },
        {
            path: "/GeneralSkill",
            component: GeneralSkill,
        },
        {
            path: "/PerformanceIndividualExpertise",
            component: PerformanceIndividualExpertise,
        },
        {
            path: "/ExtentIndividualPotentialUse",
            component: ExtentIndividualPotentialUse,
        },
        {
            path: "/WhenIndividualAction",
            component: WhenIndividualAction,
        },
        {
            path: "/SleepChartReport",
            component: SleepChartReport,
        },
        {
            path: "/SleepQuality",
            component: SleepQuality,
        },
        {
            path: "/PhysicalHealth",
            component: PhysicalHealth,
        },
        {
            path: "/LearnEachLesson",
            component: LearnEachLesson,
        },
        {
            path: "/FunctionalIntegrity",
            component: FunctionalIntegrity,
        },
        {
            path: "/ReportPage",
            component: ReportPage,
        },


    ]
});
